import EditorEvents from './wangeditor/event';
import i18n from '@/plugins/i18n';

export const defaultColor = '#2b2f38';
export const activeColor = '#2c6bff';
export const maxLength = 100000;
export { EditorEvents };

export const menuI18n = {
  uploadImage: i18n.global.t('common.editor.upload_img'),
  insertTable: i18n.global.t('common.editor.insert_table'),
  justifyLeft: i18n.global.t('common.editor.justify_left'),
  justifyCenter: i18n.global.t('common.editor.justify_center'),
  justifyRight: i18n.global.t('common.editor.justify_right'),
  bulletedList: i18n.global.t('common.editor.bulleted_list'),
  numberedList: i18n.global.t('common.editor.numbered_list'),
  undo: i18n.global.t('common.editor.undo'),
  redo: i18n.global.t('common.editor.redo')
};

const commonkeys = ['headerSelect', 'bold', 'underline', 'italic', 'through', 'color', 'bgColor', 'custom-indent'];
const menuKeys = [
  'uploadImage',
  'insertTable',
  'justifyLeft',
  'justifyCenter',
  'justifyRight',
  'bulletedList',
  'numberedList',
  'undo',
  'redo'
];

export const toolbarKeys = [
  ...commonkeys,
  {
    key: 'group-more-style', // 必填，要以 group 开头
    title: 'more-style', // 必填
    iconSvg:
      // eslint-disable-next-line max-len
      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.49012 11.9931C8.49012 12.7166 7.90361 13.3031 7.18012 13.3031C6.45662 13.3031 5.87012 12.7166 5.87012 11.9931C5.87012 11.2696 6.45662 10.6831 7.18012 10.6831C7.90361 10.6831 8.49012 11.2696 8.49012 11.9931ZM13.3085 12.0081C13.3085 12.7308 12.7227 13.3167 11.9999 13.3167C11.2772 13.3167 10.6913 12.7308 10.6913 12.0081C10.6913 11.2854 11.2772 10.6995 11.9999 10.6995C12.7227 10.6995 13.3085 11.2854 13.3085 12.0081ZM16.8194 13.3167C17.5429 13.3167 18.1294 12.7301 18.1294 12.0067C18.1294 11.2832 17.5429 10.6967 16.8194 10.6967C16.0959 10.6967 15.5094 11.2832 15.5094 12.0067C15.5094 12.7301 16.0959 13.3167 16.8194 13.3167Z" fill="#2B2F38"/></svg>',
    menuKeys
  }
];

export const expandToolbarKeys = [...commonkeys, ...menuKeys];

const fontSizeListNum = [14, 20, 24, 28, 32];
export const fontSizeList = fontSizeListNum.map((item) => {
  return {
    name: item,
    value: item + 'px'
  };
});
